import {http} from '@/services/http'
import type {Reminder} from '@/services/reminders/models'
import {addRecurring} from './utils'
import type {ReminderResponse} from './utils'

export const fetchPetReminders = async (
	locale: string
): Promise<Reminder[]> => {
	const endpoint = `/api/reminders?locale=${locale}`
	const {data} = await http<ReminderResponse>(endpoint)
	const remindersData = addRecurring(data, 12, 1)
	return remindersData.data
}
